import * as API from '../../connection/font-assets';
import { AsyncAction } from '../types/types';

export const SAVE_FONT_ASSET = 'SAVE_FONT_ASSET';
export const LOAD_FONT_ASSETS = 'LOAD_FONT_ASSETS';

export const CLEAR_FONT_UPLOAD_ALERT = 'CLEAR_FONT_UPLOAD_ALERT';

export const loadFontAssets = (
	channelId: number,
): AsyncAction => ({
	type: LOAD_FONT_ASSETS,
	promise: API.LoadFontAssets(channelId)
});

export const saveFontAsset = (
	roomId: number,
	file: File
): AsyncAction => ({
	type: SAVE_FONT_ASSET,
	promise: API.SaveFont(roomId, file)
});

export const clearFontUploadAlert = () => {
	return {
		type: CLEAR_FONT_UPLOAD_ALERT,
	}
}